// src/Dashboard.tsx
import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isActiveMember } from '@ring/shared/author-trust';
import './Dashboard.css';

// Mirrors api/src/notify.ts's STATUS_MESSAGES, shortened for an in-app banner rather than an email.
const STATUS_BANNER: Partial<Record<string, string>> = {
  pending:   "Your account is waiting for review — we'll email you once it's been approved.",
  suspended: 'Your account is currently suspended.',
  rejected:  'Your sign-up was not approved.',
};

interface DashboardTile {
  to:          string;
  title:       string;
  description: string;
}

// New tools get a tile here as they land.
const TILES: DashboardTile[] = [
  { to: '/dashboard/library',  title: 'Library',  description: 'Upload and organize the images, music and video your ads are built from.' },
  { to: '/dashboard/projects', title: 'Projects', description: 'Put your video ads together and send them off to render.' },
  { to: '/dashboard/jobs',     title: 'Renders',  description: 'Follow your renders and download the finished videos.' },
];
export function Dashboard() {
  const { author, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !author) navigate('/');
  }, [loading, author, navigate]);

  if (loading || !author) return null;

  return (
    <div className="dashboard-page">
      <h1>Welcome to Shelfkin</h1>
      <p className="dashboard-sub">Build video ads that find your kindred readers.</p>

      {STATUS_BANNER[author.authorStatus] && (
        <p className="page-notice dashboard-warning">{STATUS_BANNER[author.authorStatus]}</p>
      )}

      {isActiveMember(author.authorStatus) && (
        <div className="dashboard-grid">
          {TILES.map(tile => (
            <Link key={tile.to} to={tile.to} className="dashboard-tile">
              <h3>{tile.title}</h3>
              <p>{tile.description}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
